/**
 * Remove white-spaces from beginning and end of string.
 */
import ltrim from './ltrim';
import rtrim from './rtrim';
import WHITE_SPACES from './whitespaces';

var trim = function trim(str) {
  var chars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WHITE_SPACES;
  return ltrim(rtrim(str, chars), chars);
};

export default trim;